import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import PhoneInput from "react-phone-input-2";

import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import {
	Card,
	Alert,
	Row,
	Col,
	CardTitle,
	CardHeader,
	FormGroup,
	Label
} from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../components/CustomButton/CustomButton";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import { adminGetModuleAllocation } from "../../redux/actions/adminModuleAllocationAction";
import { AdminAllocatedModule } from "../../redux/actions/adminAllocatedModuleAction";
import { adminUpdateModuleAllocation } from "../../redux/actions/adminUpdateModuleAlloctionAction";
import { createOrUpdateWalletOwner } from "../../redux/actions/createOrUpdateWalletOwnerAction";
import { getThemeList } from "../../redux/actions/getThemeListAction";
import BackButton from "../../components/BackButton/BackButton";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const AdminModuleAllocation = () => {
	const [moduleAllocationStatus, setModuleAllocationStatus] = useState(false);
	const [moduleAllocationResArray, setModuleAllocationResArray] = useState([]);

	const [allocatedModuleStatus, setAllocatedModuleStatus] = useState(false);
	const [allocatedModuleResArray, setAllocatedModuleResArray] = useState([]);

	const [updateModuleAllocationStatus, setUpdateModuleAllocationStatus] =
		useState(false);
	const [updateModuleAllocationResArray, setUpdateModuleAllocationResArray] =
		useState([]);

	const [notificationOpen, setNotificationOpen] = useState(false);
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();
	const location = useLocation();
	const WalletOwnerId = location.search.split("?userId=")[1];

	const [allModule, setAllModule] = useState(false);

	const [allModuleList, setAllModuleList] = useState(false);

	const [moduleList, setModuleList] = useState({
		moduleListArr: []
	});

	const { moduleListArr1 } = moduleList;

	const [subModuleList, setSubModuleList] = useState({
		subModuleListArr: []
	});

	const moduleAllocationRes = useSelector(
		({ adminModuleAllocation }) => adminModuleAllocation
	);

	const allocatedModuleRes = useSelector(
		({ adminAllocatedModule }) => adminAllocatedModule
	);

	const updateModuleAllocationRes = useSelector(
		({ adminUpdateModuleAllocation }) => adminUpdateModuleAllocation
	);

	const getModuleAllocationReq = () => {
		setModuleAllocationStatus(true);
		setIsLoading(true);
		let req = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				ownerID: WalletOwnerId
			}
		};
		dispatch(adminGetModuleAllocation(req, authToken));
	};

	const allocatedModuleReq = () => {
		setIsLoading(true);
		setAllocatedModuleStatus(true);
		let req = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				ownerID: WalletOwnerId
			}
		};
		dispatch(AdminAllocatedModule(req, authToken));
	};

	const allocatedModuleFunc = () => {
		if (allocatedModuleStatus) {
			if (allocatedModuleRes.data.status == "success") {
				setAllocatedModuleResArray(
					[].concat(allocatedModuleRes.data.moduleAllocationVO)
				);
				setIsLoading(false);
			}
			if (allocatedModuleRes.data.status == "failed") {
				setAllocatedModuleResArray(allocatedModuleRes.data);
				setIsLoading(false);
				if (
					allocatedModuleRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					allocatedModuleRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		allocatedModuleFunc();
	}, [allocatedModuleRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getModuleAllocationReq();
			allocatedModuleReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	// useEffect(() => {
	// 	if (moduleAllocationRes.data.status == "success") {
	// 		allocatedModuleReq();
	// 	}
	// }, [moduleAllocationRes]);

	const getModuleAllocationFunc = () => {
		if (moduleAllocationStatus) {
			if (moduleAllocationRes.data.status == "success") {
				setModuleAllocationResArray(
					[].concat(moduleAllocationRes.data.moduleList)
				);
				setIsLoading(false);
			}
			if (moduleAllocationRes.data.status == "failed") {
				setModuleAllocationResArray(moduleAllocationRes.data);
				setIsLoading(false);
				if (
					moduleAllocationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					moduleAllocationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getModuleAllocationFunc();
	}, [moduleAllocationRes.data.status]);

	const handleChange = (e, type, value1, subModules = []) => {
		if (type == "module") {
			const { value, checked } = e.target;
			const { moduleListArr } = moduleList;
			const { subModuleListArr } = subModuleList;
			if (checked) {
				setModuleList({
					moduleListArr: [...moduleListArr, value1]
				});
				setSubModuleList({
					subModuleListArr: [
						...subModuleListArr,
						...subModules.filter(sub => !subModuleListArr.includes(sub))
					]
				});
			} else {
				setModuleList({
					moduleListArr: moduleListArr.filter((e) => e !== value1)
				});
				setSubModuleList({
					subModuleListArr: subModuleListArr.filter(sub => !subModules.includes(sub))
				});
				setAllModule(false);
			}
		}

		if (type == "subModule") {
			const { value, checked } = e.target;
			const { subModuleListArr } = subModuleList;
			if (checked) {
				setSubModuleList({
					subModuleListArr: [...subModuleListArr, value1]
				});
			} else {
				setSubModuleList({
					subModuleListArr: subModuleListArr.filter((e) => e !== value1)
				});
				setAllModule(false);
			}
		}
	};

	const updateModuleAllocationReq = () => {
		setUpdateModuleAllocationStatus(true);
		setIsLoading(true);
		let req = {
			ownerMasterRequestVO: {
				// adminId: "2",
				adminId: val.adminIDS,

				ownerID: WalletOwnerId
			},
			moduleAllocationRqVO: {
				masterModuleName: moduleList.moduleListArr,
				subModuleName: subModuleList.subModuleListArr
			}
		};
		dispatch(adminUpdateModuleAllocation(req, authToken));
	};

	const updateModuleAllocationFunc = () => {
		if (updateModuleAllocationStatus) {
			if (updateModuleAllocationRes.data.status == "success") {
				setUpdateModuleAllocationResArray(updateModuleAllocationRes.data);
				getModuleAllocationReq();
				allocatedModuleReq();
				setIsLoading(false);
				setNotificationOpen(true);
			}
			if (updateModuleAllocationRes.data.status == "failed") {
				setUpdateModuleAllocationResArray(updateModuleAllocationRes.data);
				setNotificationOpen(true);
				setIsLoading(false);
				if (
					updateModuleAllocationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateModuleAllocationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateModuleAllocationFunc();
	}, [updateModuleAllocationRes.data.status]);

	var lmn = [];
	var qwe = [];

	useEffect(() => {
		if (allocatedModuleRes.data.status == "success") {
			if (allocatedModuleRes.data.moduleAllocationVO !== null) {
				if (
					allocatedModuleRes.data.moduleAllocationVO.masterModuleMappingList
						.length
				) {
					if (
						allocatedModuleRes.data.moduleAllocationVO.masterModuleMappingList
					) {
						[]
							.concat(
								allocatedModuleRes.data.moduleAllocationVO
									.masterModuleMappingList
							)
							.map((x) => {
								if (x.slice(-1) == "Y") {
									let value = x.replace(/_Y|_N|/g, "");
									lmn.push(value);
									setModuleList({
										moduleListArr: [...lmn]
									});
								}
							});
					}

					if (
						allocatedModuleRes.data.moduleAllocationVO
							.masterSubModuleMappingList
					) {
						[]
							.concat(
								allocatedModuleRes.data.moduleAllocationVO
									.masterSubModuleMappingList
							)
							.map((x) => {
								if (x.slice(-1) == "Y") {
									let value = x.replace(/_Y|_N|/g, "");
									qwe.push(value);
									setSubModuleList({
										subModuleListArr: [...qwe]
									});
								}
							});
					}
				}
			}
		}
	}, [allocatedModuleResArray]);

	const allModuleSelect = (e) => {
		const { value, checked } = e.target;
		if (checked) {
			if (moduleAllocationRes.data.moduleList) {
				[].concat(moduleAllocationResArray).map((i) => {
					lmn.push(i.moduleName);
					if (i.subModuleList) {
						[].concat(i.subModuleList).map((j) => {
							qwe.push(j);
						});
					}
				});
			}
			setModuleList({
				moduleListArr: [...lmn]
			});
			setSubModuleList({
				subModuleListArr: [...qwe]
			});
			setAllModule(true);
		} else {
			setModuleList({
				moduleListArr: []
			});
			setSubModuleList({
				subModuleListArr: []
			});
			setAllModule(false);
		}
	};

	useEffect(() => {
		console.log(
			updateModuleAllocationResArray,
			"///////////////////////////??????????????????????????????????????????"
		);
	}, [updateModuleAllocationResArray]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	console.log('allocatedModuleRes: ', allocatedModuleRes);
	// console.log('moduleAllocationResArray: ', moduleAllocationResArray);

	return (
		<>
			<BackButton />
			<Layout>
				{isLoading ? (
					<LoadingSpinner />
				) : (
					<Card>
						<Grid container>
							<Grid item lg={2} md={2}></Grid>
							<Grid item lg={10} md={10}></Grid>
						</Grid>

						<hr />
						<br />
						<Grid container>
							<Grid item xs={12} lg={12} md={12} sm={12}>
								<h6 align="center" className="text-center themeText">
									{" "}
									Partner Module Allocation
								</h6>
							</Grid>
						</Grid>
						<Grid container style={{ padding: "10px" }}>
							<Grid
								item
								xs={12}
								sm={12}
								md={3}
								lg={3}
								style={{ marginLeft: "20px" }}
							>
								<TextField
									disabled
									autoFocus
									margin="dense"
									label="Owner ID"
									type="text"
									fullWidth
									variant="standard"
									value={WalletOwnerId}
									name=""
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								// onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={2} lg={2}></Grid>
						</Grid>
						<Grid
							item
							xs={12}
							lg={12}
							md={12}
							sm={12}
							className="ModuleAllocationHeaderColor"
							style={{
								marginTop: "20px",
								padding: "10px",

								// backgroundColor: "#00b9f5",
								// color: "#fff"
							}}
						>
							<Checkbox
								checked={allModule}
								onClick={(e) => allModuleSelect(e)}
							/>
							<span style={{ color: "#fff" }} >Select All</span>
						</Grid>
						<Grid container style={{ padding: "10px" }}>
							<Grid item xs={12} lg={4} md={4} sm={12}></Grid>
							<Grid item xs={12} lg={5} md={5} sm={12}>
								{moduleAllocationRes.data.moduleList &&
									moduleAllocationResArray.map((x) => (
										<div>
											<div>
												{/* {allocatedModuleRes.data.status == "success" &&
													allocatedModuleRes.data.moduleAllocationVO !== null &&
													allocatedModuleRes.data.moduleAllocationVO
														.masterModuleMappingList.length && ( */}
												<FormControlLabel
													style={{ marginLeft: "0px", marginTop: "10px" }}
													control={
														<Checkbox
															checked={moduleList.moduleListArr.includes(
																x.moduleName.split("_")[0] +
																"_" +
																x.moduleName.split("_")[1]
															)}
															color="primary"
														/>
													}
													label={x.moduleName.split("_")[1]}
													labelPlacement="end"
													onChange={(e) =>
														handleChange(e, "module", x.moduleName, x.subModuleList)
													}
												/>
												{/* )} */}
											</div>

											{x.subModuleList &&
												[].concat(x.subModuleList).map((y) => (
													<div
														style={{
															marginLeft: "50px"
														}}
													>
														<Checkbox
															checked={subModuleList.subModuleListArr.includes(
																y.split("_")[0] + "_" + y.split("_")[1]
															)}
															color="primary"
															onChange={(e) => handleChange(e, "subModule", y)}
														/>
														<Label
															style={{
																fontSize: "0.8rem"
															}}
														>
															{y.split("_")[1]}
														</Label>
													</div>
												))}
										</div>
									))}
							</Grid>
							<Grid item xs={12} lg={3} md={3} sm={12}></Grid>
						</Grid>
						<div
							style={{
								margin: "20px",
								textAlign: "center"
							}}
						>
							<CustomButton
								style={{
									marginLeft: "15px"
								}}
								variant="contained"
								onClick={updateModuleAllocationReq}
							>
								Save
							</CustomButton>
							{/* <Button
								size="small"
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateModuleAllocationReq}
							>
								Save
							</Button> */}
						</div>
					</Card>
				)}
			</Layout>
			{updateModuleAllocationResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateModuleAllocationResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateModuleAllocationResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateModuleAllocationResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminModuleAllocation;
